const ninjah = (greeting) => {
    return `${greeting}, yo follow me @skinnyninjah`;
};
export { ninjah };